import React, { useEffect } from 'react'
import { translate } from 'react-i18next'
import ym from 'react-yandex-metrika'
import { Helmet } from 'react-helmet'
import './style.css'

import Logo from './assets/logo.png'

import Patch1 from './assets/patch.jpg'
import Patch2 from './assets/patch2.jpg'

import Quiz1 from './assets/quiz1.png'
import Quiz2 from './assets/quiz2.png'

import Feedback from '../../../Feedback'

const PP = ({ t }) => {

    useEffect(() => {
        document.body.classList.add('pp')
        ym('hit', '/our-works/pluspatch')
        return () => {
            document.body.classList.remove('pp')
        }
    })

    return (
        <div className="app__content--project">
            <Helmet>
                <title>{ t('pp.name') }</title>
            </Helmet>
            <main className="content__ds">
                <div className="content__ds--intro mt-4">
                    <div className="content__ds--logo-container">
                        <img src={ Logo } alt={ t('pp.name') } className="content__pp--logo" />
                    </div>
                    <div className="content__ds--text">
                        <p className="content__ds--p">{ t('pp.text1') }</p>
                    </div>
                </div>

                <div className="content__pp--link">
                    <a
                        href="//plus-patch.com?utm_source=clockwork.one&utm_medium=project_description"
                        target="_blank"
                        rel="nofollow noreferrer noopener">
                        plus-patch.com
                    </a>
                </div>

                <div className="content__ds--fluid">
                    <iframe width={ 800 } height={ 450 } src="https://www.youtube.com/embed/oH3ikdvj77M" frameBorder={ 0 }
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            title="PlusPatch Promo"
                            allowFullScreen />
                </div>

                <div className="content__ds--issue">
                    <div>
                        <h2 className="content__ds--h2">{ t('issue') }</h2>
                    </div>
                    <div className="content__ds--text">
                        <p className="content__ds--p">{ t('pp.issue') }</p>
                    </div>
                </div>

                <div className="content__ds--fluid fluid--flex">
                    <img src={ Patch1 } alt={ t('pp.name') } className="fluid--small" />
                    <img src={ Patch2 } alt={ t('pp.name') } className="fluid--big" />
                </div>

                <div className="content__ds--solve">
                    <div>
                        <h2 className="content__ds--h2">{ t('solve') }</h2>
                    </div>
                    <div className="content__ds--text">
                        <p className="content__ds--p">{ t('pp.solve') }</p>
                    </div>
                </div>

                <div className="content__ds--fluid fluid--flex">
                    <img src={ Quiz1 } alt={ t('pp.name') } className="fluid--small" />
                    <img src={ Quiz2 } alt={ t('pp.name') } className="fluid--big" />
                </div>

                <section className="m-5 ma">
                    <Feedback />
                </section>

            </main>
        </div>
    )
}


export default translate('translations')(PP)



// WEBPACK FOOTER //
// ./src/Pages/Projects/PP/index.js